import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

export const ThinScrollbarContainer = styled.div`
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0) transparent;

  &:hover {
    scrollbar-color: ${color.bgSurfacePressed} transparent;
  }
`;
